import Image from 'next/image';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { IC_CLOSE_GREY } from '../../Assets/images';
import { MIN_MOBILE_WIDTH } from '../../Utility/common-utils';
import { ToastControlStyled } from './ToastControlStyled';

const ToastControl = (props) => {
  const textRef = useRef();
  const router = useRouter();
  const [size, setSize] = useState(typeof window !== 'undefined' && window.innerWidth);
  const toastControlRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const isFixed = size <= MIN_MOBILE_WIDTH ? scrollTop >= 60 : scrollTop >= 38;
      isFixed ? toastControlRef.current?.classList.add('fixed') : toastControlRef.current?.classList.remove('fixed');
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [size]);

  useEffect(() => {
    if (textRef == null) {
      return '';
    }

    if (textRef && textRef.current) textRef.current.innerHTML = props?.text || '';
  }, [props?.text, textRef]);

  useEffect(() => {
    const updateWidth = () => {
      setSize(typeof window !== 'undefined' && window.innerWidth);
    };

    window.addEventListener('resize', updateWidth);

    size <= MIN_MOBILE_WIDTH && router?.pathname && router?.pathname.includes('mycart')
      ? toastControlRef.current?.classList.add('topBarDeals')
      : toastControlRef.current?.classList.remove('topBarDeals');

    return () => window.removeEventListener('resize', updateWidth);
  }, [size, router]);

  return (
    <ToastControlStyled ref={toastControlRef} className={`tostControl ${props?.className}`} PromotionalCart={props?.PromotionalCart}>
      <div className={`${props?.variant} ${props?.dismissibleAction ? 'dismissible' : ''}`}>
        {props.imgBox && (
          <span className="img-wrapper" style={{ minWidth: props?.iconWidth }}>
            <Image src={props?.imgError} alt="error" width={props?.iconWidth} height={props?.iconHeight} />
          </span>
        )}
        <div>
          {typeof props?.text === 'object' ? (
            <div className="text">{props?.text}</div>
          ) : (
            <div className="text" ref={textRef}></div>
          )}
          <span className="grey-text">{props?.greyText}</span>
          {props.subTextBox && <div className="small-text">{props.subText}</div>}
        </div>
        <div>{props.children}</div>
        {props?.dismissibleAction && (
          <div className="close" onClick={props?.dismissibleAction}>
            <Image src={IC_CLOSE_GREY} layout="fill" alt="close icon" />
          </div>
        )}
      </div>
    </ToastControlStyled>
  );
};

ToastControl.propTypes = {
  text: PropTypes.string,
  children: PropTypes.any,
  subTextBox: PropTypes.string,
  subText: PropTypes.bool,
  imgBox: PropTypes.bool,
  PromotionalCart: PropTypes.bool,
  iconWidth: PropTypes.string,
  iconHeight: PropTypes.string,
  imgError: PropTypes.string,
  greyText: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  dismissibleAction: PropTypes.func,
};

ToastControl.defaultProps = {
  variant: '',
  className: '',
  imgBox: true,
  iconWidth: '24px',
  iconHeight: '24px',
  PromotionalCart: false,
};

export default ToastControl;
